import React from 'pureact'

const Main = ({children}) => (
  <section className="main">
    {children}
  </section>
)

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js